import { createDrawingObject, appendPoint } from "../shared";
const Eraser = {
    name: "eraser",
    createDraft: (startPoint) => createDrawingObject("eraser", [startPoint]),
    updateDraft: (draft, nextPoint) => appendPoint(draft, nextPoint),
    render: () => undefined,
};
export default Eraser;
